import React from 'react';
import includes from 'lodash/includes';
import PropTypes from 'prop-types';
import { Collapse, Col } from 'antd';
import { isNil } from 'lodash';

import { Download} from 'components';

const DownloadedVoucherItems = ({ content, docs }) => {
  return (
         <div className="file-download-container">
          {content.map((c, index) => {
            const matchedDocs = docs.filter(
              d => d && d.attachmentType === c.fileCode
            );
            return matchedDocs.length > 0 ? (
              <Download
                key={index}
                description={c.label}
                file={matchedDocs}
                simple={true}
              />
            ) : null;
          })}
    </div>
  );
};

DownloadedVoucherItems.propTypes = {
  content: PropTypes.array.isRequired,
  docs: PropTypes.array.isRequired,
};

export default DownloadedVoucherItems;
